import * as React from 'react';

export const InformationOutlineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi mdi-information-outline"></span>
);

export const DirectionsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="guide mdi mdi-directions"></span>
);

export const MapMarkerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi mdi-map-marker"></span>
);

export const ChevronUpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi mdi-chevron-up"></span>
);

export const CommentQuoteOutlineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi mdi-comment-quote-outline"></span>
);

export const EmailOutlineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi mdi-email-outline"></span>
);

export const PhoneIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi mdi-phone"></span>
);

export const PhoneOutgoingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="guide mdi mdi-phone-outgoing"></span>
);

export const LinkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi mdi-link"></span>
);

export const OpenInNewIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi guide mdi-open-in-new"></span>
);

export const FacebookIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi mdi-facebook"></span>
);

export const TwitterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi mdi-twitter"></span>
);

export const InstagramIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi mdi-instagram"></span>
);

export const YelpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi mdi-yelp"></span>
);

export const PostOutlineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className="mdi mdi-post-outline"></span>
);

export const AudioPlayerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <span className='mdi mdi-play-circle-outline'></span>
);
